import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.reducer';
import { RequestStatus } from '../../enums/request-status.enum';
import { selectCurrentDomainId } from '../domains/domains.selectors';
import { buildUserAccessProfile } from './user-access.utils';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectUser = createSelector(selectUserState, (state) => state.data);

export const selectUserStatus = createSelector(
  selectUserState,
  (state) => state.userStatus
);

export const selectUserLoading = createSelector(selectUserStatus, (status) =>
  status === RequestStatus.Loading
);

export const selectUserError = createSelector(
  selectUserState,
  (state) => state.userError
);

export const selectAccountUuid = createSelector(
  selectUser,
  (user) => user?.account?.uuid || null
);

export const selectUserAccessProfile = createSelector(
  selectUser,
  selectCurrentDomainId,
  buildUserAccessProfile
);

export const selectActiveDomainAccess = createSelector(
  selectUserAccessProfile,
  (profile) => profile?.activeDomainAccess || null
);

export const selectActivePermissions = createSelector(
  selectActiveDomainAccess,
  (domainAccess) => domainAccess?.permissions || []
);

export const selectIsAccountLevel = createSelector(
  selectUserAccessProfile,
  (profile) => Boolean(profile?.accountRole)
);

export const selectAllUserRoles = createSelector(
  selectUserAccessProfile,
  (profile) => profile?.allRoles || []
);

export const selectGlobalPermissions = createSelector(
  selectUserAccessProfile,
  (profile) => profile?.globalPermissions || []
);
